<h1
  class="mat-dialog-title"
  data-testid="shared.conflict-resolution-modal.modal-title"
>
  {{ "services.conflict" | translate }}
</h1>

<div class="mat-dialog-content">
  <div>{{ "services.suggestion-1" | translate }}</div>
  <div class="ml-2 mb-2">
    {{ params.suggestionResult.desiredCommit.formQualifiedLabel }} =
    {{ params.suggestionResult.desiredCommit.valueLabel }}
  </div>
  <div>{{ "services.suggestion-2" | translate }}</div>
  <div
    *ngFor="
      let suggestion of params.suggestionResult.suggestions;
      let i = index
    "
    class="ml-2"
    [attr.data-testid]="'shared.conflict-resolution-modal.suggestion-item-' + i"
  >
    - {{ suggestion.formQualifiedLabel }} :
    {{ suggestion.previousValueLabel }} → {{ suggestion.valueLabel }}
  </div>
</div>
<div class="flex mat-dialog-actions mt-2">
  <button
    id="cancel-button"
    class="btn btn-outline-secondary"
    data-testid="shared.conflict-resolution-modal.cancel-btn"
    (click)="onCancel()"
  >
    {{ "cancel" | translate }}
  </button>
  <button
    id="confirm-button"
    class="btn btn-info"
    data-testid="shared.conflict-resolution-modal.confirm-btn"
    (click)="onConfirm()"
  >
    {{ "confirm" | translate }}
  </button>
</div>
